export default "__VITE_ASSET__KBDDmgH8__"